function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import { useTestId } from '@wolffun/testable-id';
import DropdownList from './DropdownList';
import styles from './styles.module.scss';
import icArrowDown from '@wolffun/shared/assets/svg/ic_dropdown_fill.svg';
import icBgDropdown from '@wolffun/shared/assets/svg/ic_bg_dropdown.svg';
import Text from '../Text';

const SortSelect = ({
  value,
  placeholder,
  options,
  onSelect,
  className,
  ...opts
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const ref = React.useRef(null);
  const [selected, setSelected] = React.useState(() => {
    const index = options === null || options === void 0 ? void 0 : options.findIndex(e => e.id === value);
    return index >= 0 ? index : null;
  });
  const [collapsed, setCollapsed] = React.useState(true);
  React.useEffect(() => {
    if (value && options.length > 0) {
      const index = options.findIndex(e => e.id === value);
      setSelected(index >= 0 ? index : null);
    }
  }, [options, value]);
  React.useEffect(() => {
    if (!collapsed) {
      document.addEventListener('click', closeDropdown);
      document.addEventListener('scroll', closeDropdown);
    } else {
      document.removeEventListener('click', closeDropdown);
      document.removeEventListener('scroll', closeDropdown);
    }
  }, [collapsed]);

  const toggleDropdown = () => {
    setCollapsed(!collapsed);
  };

  const closeDropdown = () => {
    setCollapsed(true);
  };

  const selectOption = index => {
    if (index !== selected) {
      setSelected(index);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(options[index].id);
      closeDropdown();
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, opts, {
    className: classNames(styles.wrapper, className)
  }), /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: styles.container,
    onClick: e => {
      e.stopPropagation();
      toggleDropdown();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.label, selected === null && styles.placeholder)
  }, /*#__PURE__*/React.createElement(Text, {
    className: styles.spLabel,
    numberOfLines: 1
  }, selected === null ? placeholder : options[selected].label)), /*#__PURE__*/React.createElement("img", {
    draggable: false,
    className: classNames(styles.icon, !collapsed && styles.up),
    src: icArrowDown
  }), /*#__PURE__*/React.createElement("img", {
    src: icBgDropdown,
    className: styles.bg
  })), /*#__PURE__*/React.createElement(DropdownList, {
    className: classNames(styles.dropdown, collapsed && styles.hide)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, options.map((option, index) => /*#__PURE__*/React.createElement("div", {
    key: index.toString(),
    className: styles.item,
    onClick: () => selectOption(index)
  }, /*#__PURE__*/React.createElement("span", _extends({}, option.dataTestId ? generateTestIdProps('dropdown-list', option.dataTestId) : {}, {
    className: styles.title
  }), option.label))))));
};

export default SortSelect;